module.exports = __webpack_public_path__ + "img/Kwok.0f5a3d5b.jpeg";